export enum CardType {
    Hero = "Hero",
    Thumbnail = "Thumbnail",
}